import { actionCopyFr } from "./actionCopy";

export const ratingsListCopyFr = {
    addActivityPlaceholder: (current: number, max: number) => `Ajouter l'activité ${current}/${max}`,
    add: actionCopyFr.add,
    emptyHint: "Ajoutez des activités ci-dessus pour commencer à évaluer votre difficulté",
    noDifficulty: "Aucune difficulté",
    unableToDo: "Impossible à réaliser",
    loading: "Chargement des activités...",
    loadError: "Impossible de charger votre liste d'activités. Veuillez réessayer.",
    noBaselineActivities:
        "Aucune activité de référence n'a été trouvée pour ce suivi. Terminez la première saisie avant d'envoyer un suivi.",
    followUpHint: "Évaluez votre difficulté actuelle pour chaque activité choisie lors de la saisie initiale.",
};
